/**
 * Check if a pathname is a reader route.
 * Reader routes manage their own scroll behavior.
 */
export function isReaderRoute(pathname: string): boolean {
  return pathname.startsWith("/read/");
}
